import React from "react";
import { ButtonGroup, Button } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faThLarge } from "@fortawesome/free-solid-svg-icons";

export default function ListingViewToggle({ viewMode, onChange }) {
  return (
    <ButtonGroup className="listing-view-toggle">
      <Button
        className={viewMode === "grid" ? "active" : ""}
        onClick={() => onChange("grid")}
      >
        <FontAwesomeIcon icon={faThLarge} />
        <span>Grid</span>
      </Button>
      <Button
        className={viewMode === "list" ? "active" : ""}
        onClick={() => onChange("list")}
      >
        <FontAwesomeIcon icon={faList} />
        <span>Listing</span>
      </Button>
    </ButtonGroup>
  );
}
